import React, {useEffect, useState} from 'react';
import API from "../API";
import style from './instruction.module.css'
import {ReturnTextAndImg} from "../test/CheckImg";
import {ru} from "../data/ru";
import {by} from "../data/by";
const Instructions = ({setStatus}) => {
    const language = localStorage.getItem('lang') === 'ru' ? ru.instructions : by.instructions;

    const api = new API()
    const [text,setText]=useState('')
    useEffect(()=>{
        api.getInstructions().then(data=> {
            if(!data.text){
                setStatus(true)
            }
            else {
                setText(data.text)
            }
        })
    },[])
    return (
        <div className={style.container}>
            <div className={style.centerContent}>
                <div className={style.text}>{ReturnTextAndImg(text)}</div>
                <button onClick={()=>setStatus(true)}
                        className={style.buttonNext}>
                    {language.next}
                </button>
            </div>
        </div>
    );
};

export default Instructions;